import { Button } from '@billy/design-system'
import Cookies from 'js-cookie'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'

import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'
import { getInvoiceDocumentRouteBase } from '@features/invoices/utils/getInvoiceDocumentRouteBase'

import { CookieKeys } from '../../../../../../enums/cookieKeys'
import { useSegment } from '../../../../../../hooks'
import { useOrganizationViewUrl } from '../../../../../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../../../../../utils/routing/reactRoute'

export const CreateInvoiceButton = (): ReactElement => {
  const location = useLocation()
  const { t } = useTranslation()
  const { track } = useSegment()

  const invoiceDocumentRouteBase = getInvoiceDocumentRouteBase(InvoiceDocumentType.Invoice)

  const { url: invoicesNewUrl } = useOrganizationViewUrl(
    reactRoute.organization.invoices.getNewDocumentRoute(invoiceDocumentRouteBase),
  )

  const handleCreateInvoiceClick = useCallback(() => {
    track('XXX - Invoicing Core - Invoices List - Create new invoice clicked')
    Cookies.set(CookieKeys.InvoicingInvoicesListQuery, location.search)
  }, [location.search, track])

  return (
    <Button icon="circlePlus" onClick={handleCreateInvoiceClick} to={invoicesNewUrl}>
      {t('invoices.side_actions.create_invoice')}
    </Button>
  )
}
